import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import { DEFAULT_DESIGNATION_NAME } from './order-designation-utils'
import { fetchDesignation } from 'redux/services/designation'
import orderDesignationSlice from './order-designation-slice'

const useDesignationURLInitialization = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const urlParams = useSelector((state: RootState) => state.urlParams)
  const designation = useSelector((state: RootState) => state.order.designation.value)

  useEffect(() => {
    /* only proceed if
    1.- The designation id is in the url params
    2.- The current designation id matches the url param (meaning it came from url)
    3.- The current designation name is still the default (meaning it hasn't been fetched yet)
    */
    if (
      urlParams.designation &&
      designation.designationId === urlParams.designation &&
      designation.designationName === DEFAULT_DESIGNATION_NAME
    ) {
      const initializeDesignationName = async () => {
        try {
          const designationResponse = await dispatch(
            fetchDesignation.initiate({
              designationId: designation.designationId,
            }),
          ).unwrap()

          if (designationResponse && designationResponse.id === urlParams.designation) {
            dispatch(
              orderDesignationSlice.actions.setValue({
                designationId: designationResponse.id,
                designationName: designationResponse.name,
              }),
            )
          }
        } catch (error) {
          console.warn(`Failed to fetch designation name for ID ${urlParams.designation}:`, error)
        }
      }

      initializeDesignationName()
    }
  }, [])
}

export default useDesignationURLInitialization
